import React from 'react';
import './App.css';
import First from './pages/First';
import LegalPage from './pages/LegalPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:lng/about" element={<LegalPage page="about" />} />
        <Route path="/:lng/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/:lng/terms" element={<LegalPage page="terms" />} />
        <Route path="/about" element={<LegalPage page="about" />} />
        <Route path="/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />

        <Route path="/:lng/from/:source/since/:starting" element={<First />} />
        <Route path="/:lng/from/:source/event/:event" element={<First />} />
        <Route path="/:lng/from/:source" element={<First />} />
        <Route path="/:lng" element={<First />} />
        <Route path="/from/:source/since/:starting" element={<First />} />
        <Route path="/from/:source/event/:event" element={<First />} />
        <Route path="/from/:source" element={<First />} />
        <Route path="/" element={<First />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
